var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrizeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 0H2.4v2.4H0v3.2a3.2 3.2 0 0 0 2.728 3.152 4 4 0 0 0 2.744 2.336L4.92 14.4H3.2V16h9.6v-1.6h-1.72l-.552-3.312a4 4 0 0 0 2.744-2.336A3.2 3.2 0 0 0 16 5.6V2.4h-2.4V0zm-12 5.6V4h.8v2.984A1.6 1.6 0 0 1 1.6 5.6zm8 4h-.944l.8 4.8H6.544l.8-4.8H6.4A2.4 2.4 0 0 1 4 7.2V1.6h8v5.6a2.4 2.4 0 0 1-2.4 2.4zM14.4 4v1.6a1.6 1.6 0 0 1-.8 1.384V4h.8z",
    fill: "url(#ognalmp0qa)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ognalmp0qa",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A44E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeIcon);
export default __webpack_public_path__ + "static/media/prize-icon.e3900b14447cb3b61228bc703481073c.svg";
export { ForwardRef as ReactComponent };